import React, { useState } from 'react';

const INSPIRATION_IMAGES = [
  {
    id: 1,
    url: 'https://media-manager-c.questera.ai/greta-media/51defc4282d6cc0b946fc5913376bfd4a588c9e92edd50855e72016d842503cc445cfcc253280081c65053df73afdee1/images/aW1hZ2UvanBlZw==/2c7d0eed5efb83183cdb7fc1fc9822df.jpg',
    alt: 'Mouse statue in a quiet village',
    caption: 'A moment of quiet reflection in the village square',
  },
  {
    id: 2,
    url: 'https://media-manager-c.questera.ai/greta-media/51defc4282d6cc0b946fc5913376bfd4a588c9e92edd50855e72016d842503cc445cfcc253280081c65053df73afdee1/images/aW1hZ2UvanBlZw==/93823d010f082e3209bbb8dd1b62ffeb.jpg',
    alt: 'Wooden ship sailing through a forest river',
    caption: 'The forest river carries travellers far from home',
  },
  {
    id: 3,
    url: 'https://media-manager-c.questera.ai/greta-media/51defc4282d6cc0b946fc5913376bfd4a588c9e92edd50855e72016d842503cc445cfcc253280081c65053df73afdee1/images/aW1hZ2UvanBlZw==/ed2d79f71a40dbced77304e4654b5bd7.jpg',
    alt: 'Smiling stone shrine near a dark tunnel',
    caption: 'A friendly face guarding the old tunnel',
  },
  {
    id: 4,
    url: 'https://media-manager-c.questera.ai/greta-media/51defc4282d6cc0b946fc5913376bfd4a588c9e92edd50855e72016d842503cc445cfcc253280081c65053df73afdee1/images/aW1hZ2UvanBlZw==/004b27f440f876fa8d63f2a597eca0ae.jpg',
    alt: 'Bustling animal village in warm golden light',
    caption: 'Golden hour in the bustling valley',
  }
];

function ImageCard({ img, onClick }) {
  return (
    <button
      onClick={() => onClick(img)}
      className="group relative overflow-hidden rounded-md border-[1.5px] border-parchment-dark shadow-card hover:shadow-card-hover hover:-translate-y-[2px] transition-all duration-200 bg-parchment-mid text-left w-full"
    >
      <div className="overflow-hidden aspect-[4/3]">
        <img
          src={img.url}
          alt={img.alt}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="px-3 py-2 border-t border-parchment-dark">
        <p className="font-lora text-[0.78rem] italic text-ink-mid leading-snug">
          {img.caption}
        </p>
      </div>
    </button>
  );
}

function Lightbox({ img, onClose }) {
  return (
    <div
      className="fixed inset-0 bg-ink/80 backdrop-blur-[4px] z-50 flex items-center justify-center p-6"
      onClick={onClose}
    >
      <div
        className="relative max-w-3xl w-full bg-parchment rounded-lg border-2 border-parchment-dark shadow-modal overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-ink-light hover:text-ink font-lora text-2xl leading-none z-10"
        >
          &times;
        </button>
        <img
          src={img.url}
          alt={img.alt}
          className="w-full max-h-[70vh] object-contain"
        />
        <div className="px-6 py-4 border-t border-parchment-dark">
          <p className="font-playfair text-base font-bold text-ink">{img.caption}</p>
          <p className="font-lora text-[0.8rem] italic text-ink-light mt-0.5">{img.alt}</p>
        </div>
      </div>
    </div>
  );
}

export default function InspirationTab() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <div className="pl-4">
      <div className="mb-2">
        <h2 className="font-playfair text-2xl font-bold text-ink">Inspiration</h2>
        <p className="font-lora text-[0.95rem] text-ink-light mt-1">
          Images to set the mood at the table. Click any to enlarge.
        </p>
      </div>

      <div className="flex items-center gap-2 mb-6 mt-3 font-lora text-[0.78rem] italic text-ink-light">
        <span>📌</span>
        <span>Visual inspiration for our journey through Haeth.</span>
      </div>

      <div className="columns-1 sm:columns-2 lg:columns-2 gap-4 space-y-4">
        {INSPIRATION_IMAGES.map((img) => (
          <div key={img.id} className="break-inside-avoid">
            <ImageCard img={img} onClick={setLightbox} />
          </div>
        ))}
      </div>

      {lightbox && <Lightbox img={lightbox} onClose={() => setLightbox(null)} />}
    </div>
  );
}